import classes from './customerAccountComponent.scss';
import AppSpinner from '../../../../Common/CommonComponents/AppSpinner/appSpinner';
import { getLocalizedStrings } from './notificationLocalizedStrings';
import SetNotificationForResidentialCustomer from './Common/Presentational/NotificationPreferencesDialogBoxes/setNotificationCpp';
import NotificationHelper from './Common/Presentational/NotificationPreferencesDialogBoxes/dropDown/notificationHelper';
import EditPreference from "./Common/Presentational/NotificationPreferencesDialogBoxes/editPreference.js";
import RemovePreference from "./Common/Presentational/NotificationPreferencesDialogBoxes/removePreference";
class CustomerAccountComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      preferenceData: this.props.bpPreferenceSet,customerAccountData: this.props.customerData, deleteContactDetails: this.props.deleteDetails, addressBookData: this.props.addressBookData, serviceAccountData: this.props.serviceAccountData, serviceAccountsInView: this.props.serviceAccountData.saAccList, viewState: this.props.viewState, serviceCallData: this.props.serviceCallData, searchData: { searchText: '' }, selectedContactDetails: {}, setNotificationData: this.props.setNotificationData, stickyHeaderClass: '', displayDialog: false, showLoadingIndicator: this.props.showLoadingIndicator,
      isExpanded: false,selectedContractNo:'', isShowMoreCAClicked: this.props.isShowMoreCAClicked
    };
    this.selectedCustomerAccountData = {}, this.selectedContactsToRemove = [], this.selectedServiceAccount = '';
    this.strings = _.extend(this.props.strings, getLocalizedStrings('customerAccountComponent'));
    this.notificationPreferenceStrings = _.extend(this.props.strings, getLocalizedStrings('addressBook'));
    this.handleScroll = this.handleScroll.bind(this);
    this.selectedServiceAccountResidential = '', this.multiSelect = false, this.initialPositionValue = window.getComputedStyle(document.body).position, this.initialOverflowValue = window.getComputedStyle(document.body).overflow, this.assignResData = {};
  }
  componentWillReceiveProps(nextProps) {
    let noOfDisplayedAccounts;
    if (nextProps.serviceAccountData.saAccList)
      noOfDisplayedAccounts = nextProps.serviceAccountData.saAccList.length > 5 ? 5 : nextProps.serviceAccountData.saAccList.length;
    this.setState({
      preferenceData:nextProps.bpPreferenceSet, showLoadingIndicator: nextProps.showLoadingIndicator, deleteContactDetails: nextProps.deleteDetails, setNotificationData: nextProps.setNotificationData, serviceAccountsInView: nextProps.serviceAccountData.saAccList, serviceCallData: nextProps.serviceCallData, customerAccountData: nextProps.customerData, viewState: nextProps.viewState, addressBookData: nextProps.addressBookData, serviceAccountData: nextProps.serviceAccountData, noOfDisplayedAccounts: noOfDisplayedAccounts,isShowMoreCAClicked: nextProps.isShowMoreCAClicked,
    });

  }
  //Sticky Header implementation -adds event listener to scroll
  componentDidMount() {
    window.addEventListener(this.strings.scroll, this.handleScroll);
    let noOfDisplayedAccounts;
    if (this.props.serviceAccountData.saAccList)
      noOfDisplayedAccounts = this.props.serviceAccountData.saAccList.length > 5 ? 5 : this.props.serviceAccountData.saAccList.length;
    this.setState({ noOfDisplayedAccounts: noOfDisplayedAccounts, showLoadingIndicator: false });
  }



  //Sticky Header implementation-removes added event listener
  componentWillUnmount() {
    window.removeEventListener(this.strings.scroll, this.handleScroll);
  }
//Toggles the contact names view.When more than 4 contacts are there the names are trunctated . This toggles between full view and truncated view
  onContactViewChangeHandler(serviceAccountIndex) {
    let updatedServiceAccountData = { ...this.state.serviceAccountData };
    updatedServiceAccountData.saAccList[serviceAccountIndex].isExpanded = !updatedServiceAccountData.saAccList[serviceAccountIndex].isExpanded;
    this.setState({ serviceAccountData: updatedServiceAccountData });
  }
  //Toggles the value of checkbox corresponding to service accounts
  onServiceAccountSelectHandler(serviceAccountIndex) {
    let updatedServiceAccountData = { ...this.state }, selectAllFlag = true;
    if (updatedServiceAccountData.serviceAccountData.saAccList[serviceAccountIndex].isSelected && updatedServiceAccountData.customerAccountData.caList[this.selectedCustomerAccountData.customerAccountIndex].selectAllServiceAccount)
      updatedServiceAccountData.customerAccountData.caList[this.selectedCustomerAccountData.customerAccountIndex].selectAllServiceAccount = false;
      updatedServiceAccountData.selectedContractNo = updatedServiceAccountData.serviceAccountData.saAccList[serviceAccountIndex].contractNumber;
    updatedServiceAccountData.serviceAccountData.saAccList[serviceAccountIndex].isSelected = !updatedServiceAccountData.serviceAccountData.saAccList[serviceAccountIndex].isSelected;
    updatedServiceAccountData.serviceAccountsInView.map(eachAccount => {
      if (!eachAccount.isSelected) selectAllFlag = false;
    });
    updatedServiceAccountData.customerAccountData.caList[this.selectedCustomerAccountData.caListIndex].selectAllServiceAccount = selectAllFlag ? true : false;
    this.setState(updatedServiceAccountData);
  }
  onSelectAllServiceAccount() {
    let updatedCustomerAccountState = { ...this.state };
    var customerAccountIndex = updatedCustomerAccountState.customerAccountData.caList.filter(customerAccountData => parseInt(customerAccountData.contractAccountNumber) === parseInt(updatedCustomerAccountState.customerAccountData.selectedAccount))[0].caListIndex;
    updatedCustomerAccountState.customerAccountData.caList[customerAccountIndex].selectAllServiceAccount = !updatedCustomerAccountState.customerAccountData.caList[customerAccountIndex].selectAllServiceAccount;
    let serviceAccountsArray = updatedCustomerAccountState.serviceAccountData.saAccList, selectAllFlag = updatedCustomerAccountState.customerAccountData.caList[customerAccountIndex].selectAllServiceAccount;
    serviceAccountsArray.map(eachServiceAccount => {
      updatedCustomerAccountState.serviceAccountsInView.map((eachFilteredAccount, index) => {
        if (selectAllFlag) {
          if (eachServiceAccount.contractNumber === eachFilteredAccount.contractNumber && updatedCustomerAccountState.noOfDisplayedAccounts > index) eachServiceAccount.isSelected = (updatedCustomerAccountState.customerAccountData.caList[customerAccountIndex].selectAllServiceAccount === true) ? true : false;
        } 
        else
          eachServiceAccount.isSelected = false;
      });
    });
    updatedCustomerAccountState.serviceAccountData.saAccList = serviceAccountsArray;
    this.setState(updatedCustomerAccountState);
  }
  //Opens the assign contacts dialog box once any service account(s) is selected and assign is clicked
  onAssignClickHandler() {
    let updatedStateData = { ...this.state };
    this.multiSelect = true;
    updatedStateData.viewState.showResidentialSetNotification = true;
    this.props.updateViewState(updatedStateData.viewState);

  }
  //Opens the remove contacts dialog box once any service account(s) is selected and remove is clicked
  onRemoveClickHandler() {
    let updatedStateData = { ...this.state };
    this.multiSelect = true;
    updatedStateData.viewState.showRemoveContact = true;
    this.props.updateViewState(updatedStateData.viewState);
  }


  // //Closes remove/assign dialog box on click of cancel button
  cancelContactAssignmentDialogHandler(dialogId) {
    let updatedStateData = { ...this.state };
    if (dialogId === this.strings.removeContactDialog)
      updatedStateData.viewState.showRemoveContact = false;

    else if (dialogId === this.strings.removeContactResidentialDialog) {
      updatedStateData.viewState.showRemoveContact = false;
    } else if (dialogId === this.strings.assignNewContactDialog) {
      updatedStateData.viewState.showAssignContact = false, updatedStateData.viewState.assignContactFlow = false;

    } else if (dialogId === this.strings.removeContactSelectDialog) updatedStateData.viewState.showRemoveContactSelection = false;
    if (dialogId === this.strings.setNotificationDialog) {
      updatedStateData.viewState.showModifyContact = false, updatedStateData.viewState.assignContactFlow = false;
    }
    if (dialogId === this.strings.setResidentialNotificationDialog) updatedStateData.viewState.showResidentialSetNotification = false;

    if (dialogId === this.strings.previousButtonClick) {
      updatedStateData.viewState.showRemoveContact = false, updatedStateData.viewState.showRemoveContactSelection = true;
    }
    if (dialogId === 'residentialAssignCancel')
      updatedStateData.viewState.showResidentialAssign = false;

    this.props.updateViewState(updatedStateData.viewState);
  }

  //Pagination for cpp component
  showMoreLessHandler(action, totalNoOfAccounts) {
    if (action === this.strings.showLess) this.setState({ noOfDisplayedAccounts: 5 });
    else {
      if (this.state.noOfDisplayedAccounts + 25 <= totalNoOfAccounts) this.setState({ noOfDisplayedAccounts: this.state.noOfDisplayedAccounts + 25 });
      else this.setState({ noOfDisplayedAccounts: totalNoOfAccounts });
    }
  }
  /**
   * Handles OK button click in modal pop up
   */
  closeBtnClickHandler() {
    this.setState({ ...this.state, displayDialog: false });
  }
  //Opens the modal on click of icon and displays message based on type
  openToolTipModal() {
    this.setState({ ...this.state, displayDialog: true });
  }
  //Invoked om click of success button in the success dialog box .Helps in retaining the state post service call.Changes the view state as per the state passed to it before service call.
  onSuccessDialogButtonClickHandler = (updatedViewState, e) => {
    e ? e.preventDefault() : null;
    let updateState = { ...this.state };
    updateState.viewState = updatedViewState, updateState.serviceCallData.serviceCallSucceeded = false;
    (updateState.serviceCallData.serviceCallType === 'edit') ? updateState.serviceAccountData = updateState.serviceCallData.serviceAccountDataBackup : null;
    if(updateState.serviceCallData.serviceCallType === 'modifyContact' || updateState.serviceCallData.serviceCallType === 'addContact' || updateState.serviceCallData.serviceCallType === 'saveContact'){
      this.props.onServiceCallSuccessViewStateSave(this.props.customerData, true,updateState.serviceCallData.serviceCallType);
    }else if(updateState.serviceCallData.serviceCallType === 'deleteContact'){
      this.props.onServiceCallSuccessViewStateSave(this.props.customerData, true,'deleteContact');
    }else{
      this.props.onServiceCallSuccessViewStateSave(this.props.bpNumber, true,'remove');
    }
  }
  //Sticky Header implementation
  handleScroll() {
    if (!this.props.serviceCallInProgress && (this.state.serviceAccountData && (this.state.serviceAccountData.serviceAccountCount > 0)) && this.state.serviceAccountsInView.length) {
      let el = document.getElementById('sceStickyHeader');
      let parent = document.getElementById('sceContentWithStickyHeader');
    //   if (parent.getBoundingClientRect().top < 0 && parent.getBoundingClientRect().bottom >= el.getBoundingClientRect().height) {
    //     if (this.state.stickyHeaderClass !== this.strings.sceFixedHeader) this.setState({ stickyHeaderClass: this.strings.sceFixedHeader });
    //   } else if (this.state.stickyHeaderClass !== '') this.setState({ stickyHeaderClass: '' });
    }
  }

  //Fetches enrollment details for service Accounts for  residential on click of service accounts.
  onViewOrEditClickHandler(serviceAccountIndex, customerAccountIndex) {
    let updatedViewState = { ...this.state.viewState };
    updatedViewState.showResidentialSetNotification = true;
    this.selectedServiceAccount = serviceAccountIndex, this.multiSelect = false;
    this.props.updateViewState(updatedViewState);
  }
  onRemoveResidentialContact(selectedIndex) {
    let updatedStateData = { ...this.state };
    updatedStateData.viewState.showRemoveContact = true, updatedStateData.viewState.showResidentialSetNotification = false;
    this.selectedServiceAccountResidential = selectedIndex, this.multiSelect = false;
    this.props.updateViewState(updatedStateData.viewState);
  }
  overlayFocusController() {
    let overlayActive = false, viewObject = this.state.viewState;
    for (const key of Object.keys(viewObject))
      if (viewObject[key]) overlayActive = true;
    document.body.style.position = (overlayActive) ? this.strings.fixedClass : this.initialPositionValue;
    document.body.style.overflow = (overlayActive) ? this.strings.hiddenClass : this.initialOverflowValue;
  }
  filterServiceAccounts(filteredData) {
    let updatedStateData = { ...this.state };
    updatedStateData.serviceAccountsInView = filteredData;
    if (filteredData && filteredData.length) updatedStateData.noOfDisplayedAccounts = (filteredData.length > 5) ? 5 : filteredData.length;
    this.setState(updatedStateData);
  }
  saveResidentialContacts(assignData, newViewState) {
    if (!this.multiSelect || (!assignData.assignedContactPresent && this.multiSelect))
      this.props.saveResidentialContacts(assignData.enrollmentArray, newViewState, false);
    else {
      let updatedStateData = { ...this.state };
      updatedStateData.viewState.showResidentialSetNotification = false, updatedStateData.viewState.showResidentialAssign = true;
      this.assignResData = assignData;
      this.setState(updatedStateData);
    }
  }
  onModifyCustomerPreference(reqObj , newViewState, addNewDevieDetailFlag, deleteDeviceDetailFlag){
    this.props.onModifyCustomerPreference(reqObj, newViewState, addNewDevieDetailFlag, deleteDeviceDetailFlag);
  }

  render() {
    // this.overlayFocusController();
    let contactAssignmentDialogId = ['removeContactDialog', 'assignNewContactDialog', 'removeContactSelectDialog', 'setNotificationDialog', 'setResidentialNotificationDialog', 'previousButtonClick', 'removeContactResidentialDialog', 'residentialAssignCancel'], customerAccountView, customerAccountDropdown, addressBookComponent, sceDropdownLabel;
    const loadingIndicator = this.state.showLoadingIndicator ? <div className={classes.loadingSpinner}><AppSpinner /></div> : null;
    return (
      <div>
        {(this.props.isCppEnroll)?
        <div>
          <SetNotificationForResidentialCustomer
            updateViewState={this.props.updateViewState} 
            serviceCallData={this.state.serviceCallData} 
            preferenceData={this.state.preferenceData} bpNumber={this.props.bpNumber}
            hideRemoveContact 
            customerAccountData={this.selectedCustomerAccountData} 
            serviceAccountData={this.state.serviceAccountData} 
            multiSelect={this.multiSelect} 
            residentialRemoveClickHandler={(selectedIndex) => this.onRemoveResidentialContact(selectedIndex)}
            onResidentialSaveConfirmation={this.saveResidentialContacts.bind(this)} 
            sactEnrollmentDetails={this.props.sactEnrollmentDetails} 
            serviceData={this.state.serviceAccountsInView} 
            selectedServiceAccount={0} 
            onCancelSetNotification={() => this.cancelContactAssignmentDialogHandler(contactAssignmentDialogId[4])} 
            onRemoveResidentialContact={this.onRemoveResidentialContact.bind(this)} 
            viewState={this.state.viewState} 
            onModifyCustomerPreference={this.onModifyCustomerPreference.bind(this)} 
            closePopUp={this.props.closePopUp} 
            dropDownData={this.props.dropDownData} contractAccountNumber={this.props.contractAccountNumber} contractNumbercount={this.props.contractNumbercount}
            isCppErr={this.props.isCppErr} 
            />
             </div>:null}
       

      {(this.props.isViewEditOpen)?<div>
        <EditPreference 
          updateViewState={this.props.updateViewState} 
          serviceCallData={this.state.serviceCallData} 
          preferenceData={this.state.preferenceData} bpNumber={this.props.bpNumber}
          hideRemoveContact 
          customerAccountData={this.selectedCustomerAccountData} 
          serviceAccountData={this.state.serviceAccountData} 
          multiSelect={this.multiSelect} 
          residentialRemoveClickHandler={(selectedIndex) => this.onRemoveResidentialContact(selectedIndex)}
          onResidentialSaveConfirmation={this.saveResidentialContacts.bind(this)} 
          sactEnrollmentDetails={this.props.sactEnrollmentDetails} 
          serviceData={this.state.serviceAccountsInView} 
          selectedServiceAccount={0} 
          onCancelSetNotification={() => this.cancelContactAssignmentDialogHandler(contactAssignmentDialogId[4])} 
          onRemoveResidentialContact={this.onRemoveResidentialContact.bind(this)} 
          viewState={this.state.viewState} 
          onModifyCustomerPreference={this.onModifyCustomerPreference.bind(this)} 
          closePopUp={this.props.closeViewEditPopUp} 
          dropDownData={this.props.dropDownData}
          isCppErr={this.props.isCppErr} 
        />
      </div>:null} 
      {(this.props.isCppDeEnroll) ? <div>
          <RemovePreference
            isResidential multiSelect={this.props.multiSelect}
            serviceAccountData={this.state.serviceAccountData}
            closePopUp={this.props.closeDeEnrollPopUp} cppDeEnrollError={this.props.cppDeEnrollError}
            onResidentialRemoveConfirmation={this.props.saveResidentialContacts} contractAccountNumber={this.props.contractAccountNumber} contractNumbercount={this.props.contractNumbercount} 
            isCppErr={this.props.isCppErr}  />
        </div>
          : null}
      
      </div>
    );
  }
}

export default CustomerAccountComponent;
